module.exports = __webpack_public_path__ + "img/2f205d2.png";